<template>
  <div class="content">
    <div class="position">
      <p>人事行政主管</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">(1)负责贯彻执行国家有关人事方面的政策法规，结合本公司情况，制定并实施公司的人力资源规划和具体计划
      (2)定期评价本公司人力资源状况，提出人力资源开发计划并实施；
      (3)根据各部门的人力需求计划，负责对人才的引进和招聘工作进行具体操作，并制定并维护招聘渠道.
(4)制定和修改公司人力资源方面相关的规章制度，经批准后，负责监督执行；
(5)适应公司发展的实际情况和组织机构的调整，确定各部门的职务设置，并制定相应的职位说明书
(6)负责公司社会保险系统的管理及社保、福利等相关事务的办理；
(7)负责员工的人事调动、晋升、降级、辞退、离职等异动手续的相关处理；
(8)负责入职手续、人事资料收集工作及员工档案的完整性；
(9)在部门负责人领导下，指导各部门绩效考核的实施和推进绩效的管理工作，制定合理的员工薪酬制度，并根据公司发展需要适时调整薪酬方案
(10)负责公司与员工、员工与员工之间劳动关系的处理，保证劳动合同签订的及时率；
(11)负责每月的工资核算，保证及时准确的完成，交予总经理审核并签字确认；
(12)领导安排的其他事宜；
</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">(1)本科以上学历，人力资源管理、工商管理等相关专业；
(2)5年以上相关工作经验，2年以上人力资源主管工作经验，互联网行业从业经验优先；
(3)对现代企业人力资源管理模式有系统的了解和丰富的实践经验.
(4)对人力资源管理各个职能模块均有深入的认识，能够指导各个职能模块的工作；,以及相关供应链管理系统、客户关系管理系统和物流管理中的业务流程；
(5)熟悉国家、地区及企业关于合同管理、薪金制度、用人机制、保险福利待遇、培训等方面的法律法规及政策；
(6)具有战略、策略性思维，有能力建立、整合不同的工作团队；
(7)具有解决复杂问题的能力；很强的计划性和实施执行的能力；
(8)具有激励、沟通、协调、团队领导能力，责任心、事业心强；
(9)有人力资源管理师资格者优先考虑；</p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'homeJoinContent'
  }
</script>

<style scoped>

  div.content {
    margin: 2%;
    color: rgb(73, 73, 73);
  }

  div.position {
    font-family: PingFangSC-Semibold, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    text-align: left;
  }

  .statement {
    margin: 0;
    padding-bottom: 2%;
    padding-top: 2%;
  }

  p.request {
    font-size: 16px;
  }

  p.desc {
    font-size: 14px;
    line-height: 35px;
    padding-top: 2%;
  }

  p {
    text-align: left;
    white-space: pre-line;
    padding: 0;
    margin: 0;
  }

  .second {
    border-top: dashed;
    border-width: 2px;
    border-color: rgb(226,226,226);
  }

</style>



// WEBPACK FOOTER //
// HomeJoinPreduce.vue?55950b76